import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import artistStyles from "views/Artists/Styles/ArtistStyles.jsx";
// react components for routing our app without refresh
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import SectionNavbars from "views/Components/Sections/SectionNavbars.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";
import SectionCarousel from "views/Artists/Sections/ContactCarousel.jsx";



class Components extends React.Component {
  render() {
    const { classes} = this.props;

    return (


      <div>

      <SectionNavbars/>  

        <Parallax image={require("assets/img/RanchWall.jpg")}>

          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>Eide Fine Art</h1>
                  <h4><b>With its display of contemporary ceramics, paintings, and sculpture, the Eide Art Gallery 465 is one of Northern Arizona's finest art venues. Works by recognized fine artists from the United States and other countries are showcased in the gallery. The adobe complex overlooks the Verde River in Lower Sycamore Canyon.</b></h4>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)} >
          <h3 className ={classNames(classes.subtitle)} style={artistStyles.bioText}>
              Contact

             </h3>
             <p style={artistStyles.bioText}>
            <b>Dr. Joel Eide</b><br/> 
            Eide Fine Art Gallery <br/> 
            2893 W.Sullivan Ranch Road<br/> 
            Off Sycamore Canyon Road<br/> 
            PO Box 82,<br/> 
            Clarkdale, <br/>
            Arizona 86324 <br/>
            Tel. (928) 301 6105
          </p>

          <SectionCarousel/>
        </div>
        
        <Footer/>
      </div>
    );
  }
}

export default withStyles(componentsStyle)(Components);



// WEBPACK FOOTER //
// ./src/views/ContactPage/Contact.jsx